import React, { Component, useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Badge } from 'reactstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

const VendVendorContacts = (props) => {

    const [tableData, setTableData] = useState([])
    const dispatch = useDispatch()
    const selectRedux = state => state;
    const reduxData = useSelector(selectRedux);

    useEffect(() => {
        getData();
    }, [])

    useEffect(() => {//This second useEffect that does the exact same thing is due to the fact that trying to set up the dependency parameter to fire on initialize and props.vendpk change
                        //sounds like a pain. The hook is really small so just copy/pasting it isn't too hard. Looks ugly, but it gets the job done.
        getData();
    }, [props.vendpk])

    function getData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            vendpk: props.vendpk
        }
        fetch('GetVendorContacts', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },body: JSON.stringify(toSend)})
            .then((response) =>  response.json() )
            .then((responseJSON) => { setTableData(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    function renderGate() {
        let returnDiv = <div></div>
        if (tableData.length > 0) {
            returnDiv = <div>
                <Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Responsibilities</th>
                            <th>Address</th>
                            <th>Emails</th>
                            <th>Phone Numbers</th>
                            <th>Is Active?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map(item => (
                            <tr>
                                <td>{item.contactname}</td>
                                <td>{item.contactresponsibilities}</td>
                                <td>{item.address}</td>
                                <td>{item.emails.map(email => (
                                    <div><Badge>{email}</Badge><br /></div>
                                ))}</td>
                                <td>{item.phones.map(phone => (//This was really fun. item.phones is a list of objects instead of the more usual list of strings.
                                    <div><Badge color={phone.landlineflag === "1" ? "secondary" : "primary"}>{phone.number}</Badge><br /></div>
                                ))}</td>
                                <td>{item.active}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        }
        return returnDiv;
    }

    return (
        renderGate()
    )
}

export default VendVendorContacts;